import { Switch, Route } from 'react-router-dom';

import { quizRoutes } from 'types/quiz';

import CreateQuiz from './components/CreateQuiz/CreateQuiz';
import QuizDashboard from './components/QuizDashboard/QuizDashboard';
import EditQuiz from './components/EditQuiz/EditQuiz';
import CreateQuestion from './components/CreateQuestion/CreateQuestion';
import EditQuestion from './components/EditQuestion/EditQuestion';

import './Quiz.scoped.scss';

const Quiz: React.FC = () => {
  return (
    <div className="quiz-container">
      <Switch>
        <Route path={quizRoutes?.defaultPath} exact component={QuizDashboard} />
        <Route path={quizRoutes?.createQuizPath} exact component={CreateQuiz} />
        <Route path={quizRoutes?.editQuizPath} exact component={EditQuiz} />
        <Route path={quizRoutes?.questionCreateQuizPath} exact component={CreateQuestion} />
        <Route path={quizRoutes?.questionEditQuizPath} exact component={EditQuestion} />
      </Switch>
    </div>
  );
};

export default Quiz;
